import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import SectionHeader from '../components/SectionHeader';

const ProductMarginWatch = () => {
  const navigate = useNavigate();
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading]     = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const { data, error } = await supabase.rpc('get_product_margin_by_supplier');
    if (error) {
      console.error('get_product_margin_by_supplier error:', error);
      setSuppliers([]);
    } else {
      setSuppliers(data || []);
    }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const totals = suppliers.reduce((acc, s) => ({
    under_10:      acc.under_10 + Number(s.under_10 || 0),
    band_10_20:    acc.band_10_20 + Number(s.band_10_20 || 0),
    band_20_30:    acc.band_20_30 + Number(s.band_20_30 || 0),
    total_flagged: acc.total_flagged + Number(s.total_flagged || 0),
  }), { under_10: 0, band_10_20: 0, band_20_30: 0, total_flagged: 0 });

  return (
    <main className="app-main">
      <div className="page-nav">
        <button className="back-btn" onClick={() => navigate('/frontline-tools')}>← Frontline Tools</button>
        <span className="page-nav__title">Product Margin Watch</span>
        <button className="app-header__btn" onClick={load}>↻ Refresh</button>
      </div>

      <section className="section">
        <SectionHeader
          title="Active Products Below Target Margin"
          count={suppliers.length}
          onRefresh={load}
          loading={loading}
        />
        <p className="section__desc">
          Active products where retail price gives less than 30% gross profit against
          cost (cost is GST-adjusted: cost × 1.15). Grouped by supplier — click a row to see the products.
        </p>

        {loading && <div className="loading-row">Loading…</div>}

        {!loading && !!suppliers.length && (
          <table className="data-table" style={{ width: '100%' }}>
            <thead>
              <tr>
                <td style={{ fontWeight: 700, textAlign: 'right' }}>Grand Total</td>
                <td style={{ fontWeight: 700, textAlign: 'right' }}>{totals.under_10}</td>
                <td style={{ fontWeight: 700, textAlign: 'right' }}>{totals.band_10_20}</td>
                <td style={{ fontWeight: 700, textAlign: 'right' }}>{totals.band_20_30}</td>
                <td style={{ fontWeight: 700, textAlign: 'right' }}>{totals.total_flagged}</td>
              </tr>
              <tr>
                <th>Supplier</th>
                <th style={{ textAlign: 'right' }}>&lt; 10%</th>
                <th style={{ textAlign: 'right' }}>10–20%</th>
                <th style={{ textAlign: 'right' }}>20–30%</th>
                <th style={{ textAlign: 'right' }}>Total</th>
              </tr>
            </thead>
            <tbody>
              {suppliers.map(s => (
                <tr
                  key={s.supplier}
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate(`/product-margin-items?supplier=${encodeURIComponent(s.supplier)}`)}
                >
                  <td>{s.supplier}</td>
                  <td style={{ textAlign: 'right', color: 'var(--red-light, #f87171)', fontWeight: 700 }}>{s.under_10}</td>
                  <td style={{ textAlign: 'right' }}>{s.band_10_20}</td>
                  <td style={{ textAlign: 'right' }}>{s.band_20_30}</td>
                  <td style={{ textAlign: 'right', fontWeight: 700 }}>{s.total_flagged}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </main>
  );
};

export default ProductMarginWatch;
